module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Good Time Coming")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by C. S. Harris")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("GOOD TIME COMING *")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('em', [_vm._v("Sebastian St. Cyr Mysteries")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHAT ANGELS FEAR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHEN GODS DIE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHY MERMAIDS SING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHERE SERPENTS SLEEP")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHAT REMAINS OF HEAVEN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHERE SHADOWS DANCE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHEN MAIDENS MOURN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHAT DARKNESS BRINGS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHY KING CONFESS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WHO BURIES THE DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("WHEN FALCONS FALL")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('em', [_vm._v("* available from Severn House")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503df0c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0